import styled from "styled-components"

export const ListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`
export const ListItem = styled.div`
    display: flex;
    align-items: center;
    padding: 4px 12px;
    margin-bottom: 3px;
    background: ${(props) => props.theme.listItemBackground};
`
export const ListItemTitle = styled.span`
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`
export const DeleteListItemButton = styled.div`
    user-select: none;
    margin-left: 7px;
    cursor: pointer;

    & > i {
        font-weight: bold;
        font-size: ${(props) => props.theme.fontSizes.xs}px;
        color: grey;
        transition: 0.1s ease;

        &:hover {
            color: lightgrey;
            transition: 0.1s ease;
        }
    }
`
